import { Expose, Type } from "class-transformer";
import { Auftrag } from "./Auftrag";
import { IAuftrag } from "./IAuftrag";
import { IBudgetantragKostenherleitung } from "./IBudgetantragKostenherleitung";

export class BudgetantragKostenherleitung implements IBudgetantragKostenherleitung {

    isInitialized: boolean = false; // used to prevent infinite loops during initialization

    kostenHerleitungId?: number;
    budgetantragId?: number;
   
    // #region Gruppierung

    get kostengruppeArt(): string {
        return this.kostengruppeId ? this.kostengruppeId == 1 ? "Baukosten" : "Baunebenkosten (20% der Baukosten)" : "";
    }    
    kostengruppeId?: number;
    teilleistungId?: number;

    // #endregion

    // #region Ansicht Teilleistungen

    @Type(() => Auftrag)
    auftrag?: IAuftrag;
    auftragId?: number;
    auftragsnummer?: string;
    vertragsgegenstand?: string;
    firma?: string;
    firmaId?: number;
    quelle?: string;
    stand?: Date;

    huAuBauId: number | undefined;

    gesamtAuftragswert?: number;
    istStandAuftrag?: number;
    private _prognose?: number
    @Expose()
    get prognose(): number | undefined {
        if (this.auftragId && this._prognose) 
            return this._prognose;
        else
            return this.gesamtAuftragswert || this.istStandAuftrag ? Math.max(this.gesamtAuftragswert ?? 0, this.istStandAuftrag ?? 0) : undefined;
    }
    set prognose(value: number | undefined) {
        this._prognose = value;
    }

    private _basiskosten?: number;
    @Expose()
    get basiskosten(): number | undefined {
        return this._basiskosten;
    }
    set basiskosten(value: number | undefined) {
        if (this.isInitialized && this.menge) {
            // if the object is already initialized, we have to override basiskostenBudget cause of calculating basiskostenBudget by basiskosten * menge 
            this._basiskostenBudget = undefined;
        }
        this._basiskosten = value;
    }

    private _menge?: number;
    @Expose()
    get menge(): number | undefined {
        return this._menge;
    }
    set menge(value: number | undefined) {
        if (this.isInitialized && this.basiskosten) {
            // if the object is already initialized, we have to override basiskostenBudget cause of calculating basiskostenBudget by basiskosten * menge 
            this._basiskostenBudget = undefined;
        }
        this._menge = value;
    }

    private _basiskostenBudget?: number;
    @Expose()
    get basiskostenBudget(): number | undefined {
        if (this.schlussgerechnet)
            return this.istStandAuftrag ?? 0;
        else
            return this._basiskostenBudget ? this._basiskostenBudget : (this.basiskosten && this.menge ? this.basiskosten * this.menge : this.prognose);
    }
    set basiskostenBudget(value: number | undefined) {

        if (this.isInitialized) {
            // if the object is already initialized, we have to override basiskosten and menge cause of entering basiskostenBudget manually
            this._basiskosten = undefined;
            this._menge = undefined;
        }
        this._basiskostenBudget = value;
    }

    private _kostenermittlungsart?: number;
     @Expose()
	get kostenermittlungsart(): number | undefined {
         if (this.schlussgerechnet &&  ![2,4].includes(this.kostengruppeId ?? 0))  
			return 4; // Feststellung
		else
			return this._kostenermittlungsart;
    }
    set kostenermittlungsart(value: number | undefined) {
        this._kostenermittlungsart = value;
    }
    private _kostenvarianz?: number;
     @Expose()
	get kostenvarianz(): number | undefined {
         if (this.schlussgerechnet &&  ![2,4].includes(this.kostengruppeId ?? 0)) 
			return 0;
		else	
			return this._kostenvarianz;
    }
    set kostenvarianz(value: number | undefined) {
        this._kostenvarianz = value;
    }
    kostenvarianzBegruendung?: string;
    get kostenvarianzBegruendung2(): string | undefined {
        return this.kostenvarianzBegruendung;
    }
    set kostenvarianzBegruendung2(value: string | undefined) {
        this.kostenvarianzBegruendung = value;
    }
    get kostenvarianzBegruendung3(): string | undefined {
        return this.kostenvarianzBegruendung;
    }
    set kostenvarianzBegruendung3(value: string | undefined) {
        this.kostenvarianzBegruendung = value;
    }
    private _kostenvarianzWert?: number;
    @Expose()
    get kostenvarianzWert(): number | undefined {
         if (this.schlussgerechnet &&  ![2,4].includes(this.kostengruppeId ?? 0))  
            return 0;
        else
            return this.basiskostenBudget && this.kostenvarianz && this.kostenvarianz != 99
            ? Math.round(this.basiskostenBudget * this.kostenvarianz)
            : (this._kostenvarianzWert ? Math.round(this._kostenvarianzWert) : undefined);
    }
    set kostenvarianzWert(value: number | undefined) {
        this._kostenvarianzWert = value;
    }
    private _baukosten?: number;
    @Expose()
    get baukosten(): number | undefined {
        return this.basiskostenBudget || this.kostenvarianzWert 
            ? Math.round((this.basiskostenBudget ?? 0) + (this.kostenvarianzWert ?? 0)) 
            : (this._baukosten ? Math.round(this._baukosten) : undefined);
    }
    set baukosten(value: number | undefined) {
        this._baukosten = value;
    }
    dateipfadPDFKalkulation?: string;

    // #endregion

    // #region Ansicht Jahreszuordnung %
    //********************************************************************************
    // Ansicht Jahreszuordnung (%)
    //********************************************************************************
    private _jahrVergangenheitProzent?: number;
    get jahrVergangenheitProzent(): number | undefined {
        // if (this.firma) {
        //     if (this._jahrVergangenheitProzent == undefined) {
        //         // initiale Berechnung
        //         this._jahrVergangenheitProzent = this.baukosten && this.jahrVergangenheit ? (this.jahrVergangenheit / this.baukosten) :  undefined;
        //     }
        //     // wenn Firma gesetzt, dann ist das initial berechnete Feld zurückgeben, da Anpassungen an den Baukosten nicht zu einer Neuberechnung führen sollen
        //     return this._jahrVergangenheitProzent;
        // }
        
        return this.baukosten && this.jahrVergangenheit ? (this.jahrVergangenheit / this.baukosten) :  undefined;
    }
    set jahrVergangenheitProzent(value: number | undefined) {
        if (!value) {
            this.jahrVergangenheit = undefined;
        } else {
            if (this.baukosten) {
                this.jahrVergangenheit = Math.round(this.baukosten * (value ? value : 0));
            } else {
                // field should be not editable
            }   
        }
    }
    get jahr0Prozent(): number | undefined {
        return this.baukosten && this.jahr0 ? (this.jahr0 / this.baukosten) :  undefined;
    }
    set jahr0Prozent(value: number | undefined) {
        if (!value) {
            this.jahr0 = undefined;
        } else {
            if (this.baukosten) {
                this.jahr0 = Math.round(this.baukosten * (value ? value : 0));
            } else {
                // field should be not editable
            }   
        }
    }
    get jahr1Prozent(): number | undefined {
        return this.baukosten && this.jahr1 ? (this.jahr1 / this.baukosten) :  undefined;
    }
    set jahr1Prozent(value: number | undefined) {
        if (!value) {
            this.jahr1 = undefined;
        } else {
            if (this.baukosten) {
                this.jahr1 = Math.round(this.baukosten * (value ? value : 0));
            } else {
                // field should be not editable
            }   
        }
    }
    get jahr2Prozent(): number | undefined {
        return this.baukosten && this.jahr2 ? (this.jahr2 / this.baukosten) :  undefined;
    }
    set jahr2Prozent(value: number | undefined) {
        if (!value) {
            this.jahr2 = undefined;
        } else {
            if (this.baukosten) {
                this.jahr2 = Math.round(this.baukosten * (value ? value : 0));
            } else {
                // field should be not editable
            }   
        }
    }
    get jahr3Prozent(): number | undefined {
        return this.baukosten && this.jahr3 ? (this.jahr3 / this.baukosten) :  undefined;
    }
    set jahr3Prozent(value: number | undefined) {
        if (!value) {
            this.jahr3 = undefined;
        } else {
            if (this.baukosten) {
                this.jahr3 = Math.round(this.baukosten * (value ? value : 0));
            } else {
                // field should be not editable
            }   
        }
    }
    get jahr4Prozent(): number | undefined {
        return this.baukosten && this.jahr4 ? (this.jahr4 / this.baukosten) :  undefined;
    }
    set jahr4Prozent(value: number | undefined) {
        if (!value) {
            this.jahr4 = undefined;
        } else {
            if (this.baukosten) {
                this.jahr4 = Math.round(this.baukosten * (value ? value : 0));
            } else {
                // field should be not editable
            }   
        }
    }
    get jahr5Prozent(): number | undefined {
        return this.baukosten && this.jahr5 ? (this.jahr5 / this.baukosten) :  undefined;
    }
    set jahr5Prozent(value: number | undefined) {
        if (!value) {
            this.jahr5 = undefined;
        } else {
            if (this.baukosten) {
                this.jahr5 = Math.round(this.baukosten * (value ? value : 0));
            } else {
                // field should be not editable
            }   
        }
    }
    get jahrZukunftProzent(): number | undefined {
        return this.baukosten && this.jahrZukunft ? (this.jahrZukunft / this.baukosten) :  undefined;
    }
    set jahrZukunftProzent(value: number | undefined) {
        if (!value) {
            this.jahrZukunft = undefined;
        } else {
            if (this.baukosten) {
                this.jahrZukunft = Math.round(this.baukosten * (value ? value : 0));
            } else {
                // field should be not editable
            }   
        }
    }
    get jahrSummeProzent(): number | undefined {
        return (this.jahrVergangenheitProzent ?? 0) + (this.jahr0Prozent ?? 0) + (this.jahr1Prozent ?? 0) + (this.jahr2Prozent ?? 0) + (this.jahr3Prozent ?? 0) + (this.jahr4Prozent ?? 0) + (this.jahr5Prozent ?? 0) + (this.jahrZukunftProzent ?? 0);
    }
    get restProzent(): number | undefined {
        return this.baukosten ? 1.00 - (this.jahrSummeProzent ?? 0) : undefined;
    }

    // #endregion

    // #region Ansicht Jahreszuordnung abs.

    jahrVergangenheit?: number | undefined;
    jahr0?: number | undefined;
    jahr1?: number | undefined;
    jahr2?: number | undefined;
    jahr3?: number | undefined;
    jahr4?: number | undefined;
    jahr5?: number | undefined;
    jahrZukunft?: number | undefined;
    get jahrSumme(): number | undefined {
        return (this.jahrVergangenheit ?? 0) + (this.jahr0 ?? 0) + (this.jahr1 ?? 0) + (this.jahr2 ?? 0) + (this.jahr3 ?? 0) + (this.jahr4 ?? 0) + (this.jahr5 ?? 0) + (this.jahrZukunft ?? 0);
    }
    get rest(): number | undefined {
        return this.baukosten ? this.baukosten - (this.jahrSumme ?? 0) : undefined;
    }
    get kontrolle(): boolean | undefined {
        if (this.rest == undefined) return undefined;
        return (this.rest !== 0);
    }

    // #endregion

    // #region Ansicht Verlauf

    baukostenLetztgueltig?: number;
    get differenzLetztgueltig(): number | undefined {
        return this.baukostenLetztgueltig && this.baukosten ? this.baukosten - this.baukostenLetztgueltig : undefined;
    }
    get differenzLetztgueltigProzent(): number | undefined {
        return this.differenzLetztgueltig && this.baukostenLetztgueltig  ? 100 / this.baukostenLetztgueltig * this.differenzLetztgueltig / 100 : undefined;
    }

    veraenderungBegruendung?: string;
    huAuBauBegruendung?: string;
    get huAuBauBegruendung2(): string | undefined {
        return this.huAuBauBegruendung;
    }
    set huAuBauBegruendung2(value: string | undefined) {
        this.huAuBauBegruendung = value;
    }

    // #endregion

    schlussgerechnet: boolean = false;
	disabled: boolean = false;

    constructor(init?: Partial<IBudgetantragKostenherleitung>) {
        Object.assign(this, init);
    }
}